import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";
import * as Service from "../../services/Service.js";

// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';
import { addDays, subDays } from "date-fns";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "tabulator-tables/dist/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useQuery } from "@tanstack/react-query";
import * as api from "../../actions/api";

import {
  Typography,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Select,
  FormLabel,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

import { Button } from "reactstrap";

// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

// Highcharts component
import Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting.js";
import "highcharts/modules/accessibility.js";
import HighchartsReact from "highcharts-react-official";

import DefaultFooter from "components/Footers/DefaultFooter";
import { getDefaultMonthYear, getARVFacilityList } from "../../services/Common";

import { useTranslation } from "react-i18next";
import {checkLogin, checkUserPermission,getUserActionPermission} from "../../services/CheckUserAccess";
import encryptionService from "../../services/encryptionService";


const PatientStatusReport = (props) => {
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "patient-status";
  const FacilityId = localStorage.getItem("FacilityId");
  const YearList = JSON.parse(localStorage.getItem("YearList"));
  const MonthList = JSON.parse(localStorage.getItem("MonthList"));
 // const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));
/*   const bFacilitySelected = localStorage.getItem("bFacilitySelected"); */

/*   let All_Facility_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All Facility"]),
  };
  const FacilityList = [All_Facility_label].concat(getARVFacilityList());  */
  //const FacilityList = [All_Facility_label].concat(Facility_List);
  // const MosTypelist = JSON.parse(localStorage.getItem("MosTypelist"));
  //const bFacilitySelected = localStorage.getItem("bFacilitySelected");


  
              
/* =============Start Department, Zone, Commune, Facility Dipendency=============  */
const bFacilitySelected = localStorage.getItem("bFacilitySelected");
const UserInfo = encryptionService.decryptUserInfo();
const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
Regionlist.unshift(objAll);
const [currRegionId, setcurrRegionId] = useState(
  bFacilitySelected == 1 ? defaultRegionId : 0
);
const [chosenValuesRegion, setChosenValuesRegion] = useState(
  bFacilitySelected == 1
    ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
    : objAll
);

let TempZSList = useState([]);
const [ZoneList, setZoneListLocal] = useState(TempZSList);
//const [currZoneId, setcurrZoneId] = useState(0);
const [currZoneId, setcurrZoneId] = useState(
  bFacilitySelected == 1 ? defaultZoneId : 0
);
const [chosenValuesZone, setChosenValuesZone] = useState({});

let TempCommuneList = useState([]);
const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
//const [currCommuneId, setcurrCommuneId] = useState(0);
const [currCommuneId, setcurrCommuneId] = useState(
  bFacilitySelected == 1 ? defaultDistrictId : 0
);
/* const [chosenValuesDistrict, setChosenValuesDistrict] = useState({
  "DistrictId": objAll
}); */

const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

let TempFacilityList = useState([]);
const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);
const [currFacilityId, setcurrFacilityId] = useState(
  bFacilitySelected == 1 ? FacilityId : 0
);
const [chosenValuesFacility, setChosenValuesFacility] = useState({});

React.useEffect(() => {
  cZoneList();
}, [currRegionId]);

React.useEffect(() => {
  cCommuneList();
}, [currRegionId, currZoneId]);

React.useEffect(() => {
  cFacilityList();
}, [currRegionId, currZoneId, currCommuneId]);

//====== Start Choosen Dropdown===========

const handleChangeChoosenRegion = (name, valueobj, value) => {
  /*  let chosenValuesDataRegion = { ...chosenValuesRegion};
chosenValuesDataRegion[name] = valueobj; */
  setChosenValuesRegion(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrRegionId(value);

  setcurrZoneId(0);
  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesZone(objAll);
  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenZone = (name, valueobj, value) => {
  /* let chosenValuesDataZone = { ...chosenValuesZone};
chosenValuesDataZone[name] = valueobj; */
  setChosenValuesZone(valueobj);

  /* setFirstLoad(true); */
  //setLoading(false);
  setcurrZoneId(value);

  setcurrCommuneId(0);
  setcurrFacilityId(0);

  setChosenValuesDistrict(objAll);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenDistrict = (name, valueobj, value) => {
  /* let chosenValuesDataDistrict = { ...chosenValuesDistrict};
chosenValuesDataDistrict[name] = valueobj; */
  setChosenValuesDistrict(valueobj);

  //setLoading(false);
  setcurrCommuneId(value);

  setcurrFacilityId(0);
  setChosenValuesFacility(objAll);
};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  /*  let chosenValuesDataFacility = { ...chosenValuesFacility};
chosenValuesDataFacility[name] = valueobj; */
  setChosenValuesFacility(valueobj);

  //setLoading(false);
  setcurrFacilityId(value);
};

//====== End Choosen Dropdown===========

const cZoneList = () => {
  let ZoneListParam = {
    action: "Zonelist",
    RegionId: currRegionId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", ZoneListParam)
    .then((res) => {
      let All_Zone_label = objAll;
      const Zone_List = [All_Zone_label].concat(res.datalist);
      setZoneListLocal(Zone_List);

      let defaultZoneDDD =
        (Zone_List.find((list) => list.id == currZoneId) ?? null);
      /* let chosenValuesDataZoneAA = {};
      chosenValuesDataZoneAA["ZoneId"] = defaultZoneDDD; */
      setChosenValuesZone(defaultZoneDDD);
    })
    .catch((err) => {});
};

const cCommuneList = () => {
  let CommuneListParam = {
    action: "Communelist",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", CommuneListParam)
    .then((res) => {
      let All_Commune_label = objAll;
      const Commune_List = [All_Commune_label].concat(res.datalist);
      setCommuneListLocal(Commune_List);

      let defaultCommune =
        (Commune_List.find((list) => list.id == currCommuneId) ?? null);
      /* let chosenValuesDataCommune = {};
    chosenValuesDataCommune["DistrictId"] = defaultCommune; */
      setChosenValuesDistrict(defaultCommune);
    })
    .catch((err) => {});
};

const cFacilityList = () => {
  let FacilityListParam = {
    action: "ARVFacilityListByDepartmentZoneCommune",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    DistrictId: currCommuneId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", FacilityListParam)
    .then((res) => {
      let All_Facility_label = objAll;
      const Facility_List = [All_Facility_label].concat(res.datalist);
      setFacilityListLocal(Facility_List);
      let defaultFacilityDDD =
        (Facility_List.find(
            (facilitylist) => facilitylist.id == currFacilityId
          ) ?? null);

      /* let chosenValuesDataFacilityAA = {};
      chosenValuesDataFacilityAA["FacilityId"] = defaultFacilityDDD; */

      setChosenValuesFacility(defaultFacilityDDD);
    })
    .catch((err) => {});
};

/* =============End Department, Zone, Commune, Facility Dipendency=============  */
 

  const classes = useStyles();

  const [pickerData, setPickerData] = useState([
    {
      startDate: subDays(new Date(), 29),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isLoadingDashboard, setLoading] = useState(true);
 /*  const [currFacilityId, setCurrFacilityId] = useState(bFacilitySelected == 1? FacilityId: 0); */
  
  const [currYearId, setCurrYearId] = useState(
    getDefaultMonthYear().defaultYear
  );
  const [currMonthId, setCurrMonthId] = useState(
    getDefaultMonthYear().defaultMonthId
  );

  const handleYearChange = (event) => {
    setCurrYearId(event.target.value);
  };

  const handleMonthChange = (event) => {
    setCurrMonthId(event.target.value);
  };


/*   const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 };
 */

  /*   const handleFacilityChange = (event) => {
    setCurrFacilityId(event.target.value);
  }; */

  /*   const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 }; */

  const [nationalStockCategory, setNationalStockCategory] = useState([]);
  const [nationalStockData, setNationalStockData] = useState([]);
  const [nationalStockDateRange, setnationalStockDateRange] = useState([]);

  let params1 = {
    action: "getPatientStatusReportTable",
    menukey: menukey,
    RegionId: currRegionId,
    ZoneId: currZoneId,
    CommuneId: currCommuneId,
    FacilityId: currFacilityId,
    Month: currMonthId,
    Year: currYearId,
  };
  const [dataItems, setDataItems] = useState([]);
  const { refetch } = useQuery([params1], api.getPatientStatusReportTable, {
    onSuccess: (data) => {
      setDataItems(data);
    },
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 0, //1000 * 60 * 60 * 24,
  });

  useEffect(() => {
    if (currYearId > 0 && currMonthId > 0) {
      // getConsumptionTrendsTopFiveProducts.refetch();
    }
  }, [currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId]);

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  const [hasUserPermission, setHasUserPermission] = React.useState(false);

 /*  const checkLogin = () => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: "token expired. Please login again",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          window.location.href = process.env.REACT_APP_BASE_NAME + `/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  React.useEffect(() => {
    // checkLogin();
  }, []);

  const handleDatePicker = (e) => {};

  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      formatter: "rownum",
      width: 35,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Protocol"]),
      field: "RegimenName",
      width: 140,
      headerSort: false,
      frozen: true,
      // headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["File Active"]),
      hozAlign: "center",
      headerHozAlign: "center",
      frozen: true,
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "FileActiveAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          headerSort: false,
          width: 55,
          bottomCalc: "sum",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "FileActivePaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "FileActiveTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["New Patient"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "NewAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "NewPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "NewTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Transfer In"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "TransInAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "TransInPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "TransInTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },


    {
      title: t(DispensingLanguage[lan][menukey]["Transfer In International"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "TransInInternationalAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "TransInInternationalPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "TransInInternationalTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Ltfu Return"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "LtfuRetAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 60,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "LtfuRetPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 85,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "LtfuRetTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Total"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "NewTransInLtfuRetAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "NewTransInLtfuRetPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "NewTransInLtfuRetTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Status Quo"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "StatuQuoAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "StatuQuoPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "StatuQuoTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Change Protocol"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "ChangeProtocolAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 60,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "ChangeProtocolPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 85,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "ChangeProtocolTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Migration L1 vers L2"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "L1toL2AdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "L1toL2PaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "L1toL2Total",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Migration L2 vers L3"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "L2toL3AdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "L2toL3PaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "L2toL3Total",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Migration L1 vers L3"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "L1toL3AdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "L1toL3PaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "L1toL3Total",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Total"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightgreen",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "MonitorAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "MonitorPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "MonitorTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightgreen",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Transfer Out"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "TransOutAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "TransOutPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "TransOutTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Transfer Out International"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "TransOutInternationalAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "TransOutInternationalPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "TransOutInternationalTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Perdu de vue (LTFU)"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "LtfuAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "LtfuPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "LtfuTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Died"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "DiedAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "DiedPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "DiedTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Total"]),
      hozAlign: "center",
      headerHozAlign: "center",
      cssClass: "tabluator-column-lightyellow",
      columns: [
        {
          title: t(DispensingLanguage[lan][menukey]["Adult"]),
          field: "OutAdultPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 55,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Paediatric"]),
          field: "OutPaediatricPatient",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 80,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
        {
          title: t(DispensingLanguage[lan][menukey]["Total"]),
          field: "OutTotal",
          hozAlign: "right",
          headerHozAlign: "right",
          headerFilter: false,
          width: 50,
          headerSort: false,
          bottomCalc: "sum",
          cssClass: "tabluator-column-lightyellow",
          formatter: function (cell, formatterParams) {
            let value = cell.getValue();
            return value == 0 ? "" : value;
          },
        },
      ],
    },
  ];

/* =====Start of Excel Export Code==== */
const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

const ExcelExport = () => {
  //let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
  let finalUrl = EXCEL_EXPORT_URL + "report/patient_status_report_excel.php";
  let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
  let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
  let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
  let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;



    window.open(
      finalUrl +"?menukey=" +menukey
        + "&lan=" + localStorage.getItem("LangCode")
        +"&Month=" + currMonthId
        + "&Year=" + currYearId  + 
        "&RegionId=" + currRegionId +
        "&ZoneId=" + currZoneId +
        "&CommuneId=" + currCommuneId +
        "&FacilityId=" + currFacilityId +
        "&FacilityName=" + currFacilityName +
        "&DepartmentName=" + currDepartmentName +
        "&ZoneName=" + currZoneName +
        "&CommuneName=" + currCommuneName 
        + "&TimeStamp=" + Date.now()
    );
};

const PrintExport = () => {
  //let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
  let finalUrl = EXCEL_EXPORT_URL + "report/patient_status_report_print.php";
  let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
  let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
  let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
  let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;


    window.open(
      finalUrl +"?menukey=" +menukey
        + "&lan=" + localStorage.getItem("LangCode")
        +"&Month=" + currMonthId
        + "&Year=" + currYearId
        + "&RegionId=" + currRegionId +
        "&ZoneId=" + currZoneId +
        "&CommuneId=" + currCommuneId +
        "&FacilityId=" + currFacilityId +
        "&FacilityName=" + currFacilityName +
        "&DepartmentName=" + currDepartmentName +
        "&ZoneName=" + currZoneName +
        "&CommuneName=" + currCommuneName 
        + "&TimeStamp=" + Date.now()
    );
};


/* =====End of Excel Export Code==== */

  return (
    hasUserPermission && (
        <>
          <AfterLoginNavbar {...props} />

          <div
            className="section signup-top-padding"
            style={{
              backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
              backgroundSize: "cover",
              backgroundPosition: "top center",
              minHeight: "753px",
            }}
          >
            <div className="dashboard-pannel">
              <div className="d-flex justify-product mb-1">
                <div className="sw_page_heading">
                  <div className="sw_heading_title">
                    {t(DispensingLanguage[lan][menukey]["Patient Status Report"])}
                  </div>
                </div>
              </div>

              {/* start of filter */}
              <Card className="sw_card sw_filter_card">
                <CardContent className="sw_filterCardContent">
                  <Grid container spacing={1}>
                    <Grid item xs={1} sm={1}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                      {DispensingLanguage[lan][menukey]["Year"]}
                    </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="YearList"
                          name="YearList"
                          value={currYearId}
                          onChange={handleYearChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Year"]}>
                          {YearList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={1} sm={1}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                      <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Month"]}
                      </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="MonthList"
                          name="MonthList"
                          value={currMonthId}
                          onChange={handleMonthChange}
                          fullWidth
                        label={DispensingLanguage[lan][menukey]["Month"]}>
                          {MonthList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </Grid>


                    

                    <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="RegionId"
                            options={Regionlist}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenRegion(
                                "RegionId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesRegion}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  DispensingLanguage[lan][menukey]["Department"]
                                }
                                variant="standard"
                                id="RegionId"
                                name="RegionId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="ZoneId"
                            options={ZoneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenZone(
                                "ZoneId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesZone}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["ZS"]}
                                variant="standard"
                                id="ZoneId"
                                name="ZoneId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="DistrictId"
                            options={CommuneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenDistrict(
                                "DistrictId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesDistrict}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Commune"]}
                                variant="standard"
                                id="DistrictId"
                                name="DistrictId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="FacilityId"
                            options={FacilityList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenFacility(
                                "FacilityId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesFacility}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Facility"]}
                                variant="standard"
                                id="FacilityId"
                                name="FacilityId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    

                  
                   {/*  <Grid item xs={3} sm={3}>
                      <FormControl className={classes.fullWidth}>
                       
                        <Autocomplete
                          autoHighlight
                          className="sw_chosen_filter"
                          id="FacilityList"
                          disableClearable
                          options={FacilityList}
                          onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                          getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                          defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                          renderOption={(props, option) => (
                            <li {...props} key={option.id ?? option.name}>
                              <Typography className="sw_fontSize">{option.name}</Typography>
                            </li>
                          )}
                          
                          renderInput={(params) => (
                          <TextField
                            {...params}
                            // label={DispensingLanguage[lan][menukey]["All Facility"]}
                            variant="standard"
                            hiddenLabel
                          />
                          )}
                        />


                      </FormControl>
                    </Grid> */}

                    <Grid item xs={1} sm={1}>
                      <div className="float-end sw_btn_control">

                        
                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => ExcelExport()}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button>

                        {/* <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("print")}
                        >
                          <i className="fas fa-print"></i>
                        </Button>

                        <Button
                          color="info"
                          className="me-2 sw_icons"
                          onClick={() => PrintPDFExcelExportFunction("excel")}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button> */}
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* end of filter */}

              {/* new row */}
              <div className="row">
                <div className="col-md-12">
                  <Card className="sw_card">
                    {/*  <CardHeader
                      
                    /> */}

                    <CardContent>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="uniqueName">
                            <ReactTabulator
                              columns={columns}
                              data={dataItems}
                              layout={"fitDataFill"}
                              height="530px"
                              options={
                                {
                                  //groupBy: ["GroupName", "ItemName"],
                                  // groupBy: "GroupName",
                                  // columnCalcs: "both",
                                }
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
              {/* end row */}
            </div>
          </div>
        </>)
  );
};

export default PatientStatusReport;

const useStyles = makeStyles({
  root: {
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  },
  fullWidth: {
    width: "100%",
  },
});
